import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

/**
 * Custom TranslateLoader for Angular 22 compatibility
 * Works around NG0201 injection issue with @ngx-translate/http-loader v17
 * 
 * Accepts HttpClient via constructor instead of using inject() internally
 */
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateHttpLoader extends TranslateLoader {
  constructor(private http: HttpClient) {
    super();
  }

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`./assets/i18n/${lang}.json`);
  }
}
